<template>
  <base-dropdown class="c-base-date-dropdown" v-model="isActive" :header-title="displayDate" is-mobile-fullscreen v-on="events" :placement="placement">
    <template v-slot:button="{ toggle, identifier }">
      <base-tooltip static-class="lg-down:hidden">
        <base-button :id="identifier" :class="[{ 'active': isActive }]" :title="displayDate" :icon-prepend="['fal', 'calendar-alt']" variant="outline-primary-alt" @click="toggle" tabindex="0" slot="reference" />
        <base-shortcut :title="$t('shortcuts.accessDateFilter')" :combinations="[{ icon: ['fal', 'arrow-alt-up'] }, { content: 'D' }]" is-small/>
      </base-tooltip>
    </template>
    <div class="flex sm-down:flex-col">
      <ul v-if="showPresets" class="c-date-presets">
        <li v-for="(value, key) in presets" class="c-date-presets__item" :key="key">
          <base-button class="c-date-presets__button" :title="key" variant="link" @click="onPresetClick(value)"/>
        </li>
      </ul>

      <base-date-picker v-model="localValue" v-bind="$attrs" :is-date-range="isDateRange" />
    </div>

    <template slot="footer" slot-scope="{ ok, cancel }">
      <div class="flex">
        <base-button :title="$t('label.clear{label}', { label: $t('label.date') })" variant="link-danger" @click="onClearInputClick"/>
        <div class="ml-auto">
          <base-button :title="$t('label.cancel')" variant="link-danger" @click="cancel()"/>
          <base-button :title="$t('label.apply')" variant="secondary" is-pill class="ml-3" @click="ok()"/>
        </div>
      </div>
    </template>
  </base-dropdown>
</template>

<script>
import { shortcut } from '@/mixins/helpers'

export default {
  name: 'BaseDateDropdown',

  inheritAttrs: false,

  mixins: [ shortcut ],

  props: {
    value: {
      type: [Object, Date],
      default: function () {
        return this.isDateRange ? { } : null
      }
    },
    placeholder: {
      type: String
    },
    isDateRange: {
      type: Boolean,
      default: true
    },
    showPresets: {
      type: Boolean,
      default: true
    },
    presets: {
      type: Object,
      default () {
        return {
          [this.$i18n.t('label.today')]: { startDate: this.$moment().startOf('day'), endDate: this.$moment().endOf('day') },
          [this.$i18n.t('label.yesterday')]: { startDate: this.$moment().subtract(1, 'days').startOf('day'), endDate: this.$moment().subtract(1, 'days').endOf('day') },
          [this.$i18n.t('label.this{label}', { label: this.$i18n.t('label.week') })]: { startDate: this.$moment().startOf('week'), endDate: this.$moment().endOf('day') },
          [this.$i18n.t('label.last{label}', { label: this.$i18n.t('label.week') })]: { startDate: this.$moment().subtract(1, 'week').startOf('week'), endDate: this.$moment().subtract(1, 'week').endOf('week') },
          [this.$i18n.t('label.this{label}', { label: this.$i18n.t('label.month') })]: { startDate: this.$moment().startOf('month'), endDate: this.$moment().endOf('day') },
          [this.$i18n.t('label.last{label}', { label: this.$i18n.t('label.month') })]: { startDate: this.$moment().subtract(1, 'month').startOf('month'), endDate: this.$moment().subtract(1, 'month').endOf('month') },
          [this.$i18n.t('label.this{label}', { label: this.$i18n.t('label.year') })]: { startDate: this.$moment().startOf('year'), endDate: this.$moment().endOf('day') },
          [this.$i18n.t('label.last{label}', { label: this.$i18n.t('label.year') })]: { startDate: this.$moment().subtract(1, 'year').startOf('year'), endDate: this.$moment().subtract(1, 'year').endOf('year') }
        }
      }
    },
    placement: {
      type: String,
      default: 'bottom-start'
    }
  },

  data () {
    return {
      isActive: false,

      localValue: this.value,

      events: {
        ok: () => this.onApply()
      }
    }
  },

  computed: {
    shortcuts () {
      return [
        { combinations: 'shift+d', action: 'keypress', handler: this.onToggle }
      ]
    },

    displayDate () {
      if (this.value && (this.isDateRange ? (this.value.startDate && this.value.endDate) : this.value)) {
        if (this.isDateRange) {
          const { startDate, endDate } = this.value
          return startDate.getDate() === endDate.getDate() && startDate.getMonth() === endDate.getMonth() && startDate.getYear() === endDate.getYear()
            ? this.$i18n.d(this.value.startDate, 'short')
            : this.$i18n.d(startDate, 'short') + ' - ' + this.$i18n.d(endDate, 'short')
        } else {
          return this.$i18n.d(this.value, 'short')
        }
      } else {
          return this.placeholder || this.$i18n.t('label.selectDateRange')
        }
    }
  },

  methods: {
    onPresetClick (preset) {
      this.localValue = this.isDateRange ? { startDate: preset.startDate.toDate(), endDate: preset.endDate.toDate() } : preset.toDate()
    },

    onClearInputClick () {
      this.localValue = this.isDateRange ? { startDate: null, endDate: null } : null
    },

    onToggle () {
      this.isActive = !this.isActive
    },

    onApply () {
      this.$emit('input', this.localValue)
    }
  }
}
</script>
